export default __webpack_public_path__ + "static/media/DAIF_Eco_In.bae47905.mp4";